import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'gatsby';
import styles from './Menu.module.scss';
import cnames from 'classnames';

const Menu = ({ items, className, theme, onClick }) => (
  <nav className={cnames(styles.menu, styles[theme], className)}>
    <ul>
      {items.map(item =>
        <li onClick={onClick} key={item.path}>
          <Link to={item.path}
            className={cnames(styles.link)}
            activeClassName={styles.active}
          >
            {item.title}
          </Link>
        </li>
      )}
    </ul>
  </nav>
);

Menu.propTypes = {
  onClick: PropTypes.func,
  items: PropTypes.arrayOf(PropTypes.shape({
    title: PropTypes.string.isRequired,
    path: PropTypes.string.isRequired,
  })),
  theme: PropTypes.oneOf(['primary', 'secondary']),
};

Menu.defaultProps = {
  theme: 'secondary',
}

export default Menu;
